module.exports = __webpack_public_path__ + "img/portalmanagement_visits.3c6b6ab1.png";